import React from 'react'

import { formatMoney } from '@utils/money'
import { useConfigurationStore } from '@stores'
import { AtlasImageStyles } from '@utils/buildAtlasImageStyles'
import ImageTemplate from './ImageTemplate'
import { BuildGradientStyle } from '@utils/buildGradientStyle'
import { useTranslation } from '@amusnet/translations/react'

export type DeclineBonusInfo = {
    betValue: string
    bundleDetails: { styles: string; text: string }[]
}

export type DeclineBonusStyles = {
    primaryTextColor: string
    secondaryTextColor: string
    image?: string
    imageStyles?: AtlasImageStyles
    background: BuildGradientStyle
}

interface DeclineProps {
    bonusInfo?: DeclineBonusInfo
    styles: DeclineBonusStyles
}

const DeclineTemplate: React.FC<DeclineProps> = ({ bonusInfo, styles }) => {
    const { t } = useTranslation()
    const currencyHideCents = useConfigurationStore((state) => state.currencyHideCents)
    const currency = useConfigurationStore((state) => state.currency)

    if (bonusInfo) {
        const betValue = formatMoney(Number(bonusInfo.betValue), currencyHideCents)

        return (
            <div className="flex flex-col items-center justify-between h-full">
                <div className="flex flex-col w-full">
                    <ImageTemplate image={styles.image} imageStyles={styles.imageStyles} />

                    <div
                        id="bonus-decline-confirmation"
                        style={{ ...styles.background }}
                        className="flex flex-col items-center w-full mt-[-3px] pb-4"
                    >
                        <p
                            style={{ color: styles.primaryTextColor }}
                            className="text-4xl font-bold text-center px-[87px] leading-relaxed"
                        >
                            {t('gameui.bonusSystem.singleDeclineText')}
                        </p>

                        {bonusInfo.bundleDetails.map((details) => (
                            <p style={{ color: styles.secondaryTextColor }} className={details.styles}>
                                {details.text}
                            </p>
                        ))}

                        <p style={{ color: styles.primaryTextColor }} className="text-4xl font-black">
                            x {betValue} {currency}
                        </p>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="flex flex-col items-center justify-between">
            <div className="flex flex-col w-full">
                <ImageTemplate image={styles.image} imageStyles={styles.imageStyles} />

                <div
                    id="bonuses-decline-confirmation"
                    style={{ ...styles.background }}
                    className="flex flex-col items-center w-full h-[278px] mt-[-3px]"
                >
                    <p className={`text-4xl font-bold text-center pt-[84px] px-[87px] ${styles.primaryTextColor}`}>
                        {t('gameui.bonusSystem.declineAllText')}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default DeclineTemplate
